// extracted by mini-css-extract-plugin
export default {"wrapper":"Qy-z","response":"Ry-z","error":"Sy-z","disabled":"Ty-z","buttons":"Uy-z","feedbackQuestionSection":"Vy-z","yesNoWrapper":"Wy-z"};